import { Chip, Grid } from "@material-ui/core";
import InfoIcon from "@material-ui/icons/Info";
import * as React from "react";
import { getApprovalInfo, getCreatedByInfo, isOpenInfo } from "../../../../Helper/CreateApprovelFunctions";

const gridContainerProps: any = {
  container: true,
  direction: "row",
  item: true,
  xs: 12,
  spacing: 1,
  justify: "space-around",
  alignItems: "center",
};

const PbhUnserviceableStatusChip = ({ unserviceable }) => {
  return (
    <Grid {...gridContainerProps}>
      <Chip
        key={88889999}
        color="primary"
        variant="outlined"
        label={getCreatedByInfo(unserviceable?.createdByName, unserviceable?.createdDate)}
        icon={<InfoIcon />}
      />
      {isOpenInfo(unserviceable?.acceptedDate, unserviceable?.rejectedDate) && (
        <Chip
          key={88889999}
          color="primary"
          variant="outlined"
          label={getApprovalInfo(
            unserviceable?.acceptedBy,
            unserviceable?.acceptedDate,
            unserviceable?.rejectedBy,
            unserviceable?.rejectedDate
          )}
          icon={<InfoIcon />}
        />
      )}
    </Grid>
  );
};

export default PbhUnserviceableStatusChip;
